module.exports = __webpack_public_path__ + "static/media/video.83d9b70f.png";